




















































































































































































import { Device, Meter } from "@/api/baseDefine";
import mqtt from "mqtt";
import { GetMetersReq, meters } from "@/api/meter";
import {
  sendDeviceCommand,
  SendDeviceCommandReq,
  getConfig,
} from "@/api/device";
import MeterChatDialog from "@/components/dialog/meterChatDialog.vue";
import MeterEditDialog from "@/components/dialog/meterEditDialog.vue";
import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import { globalData } from "@/utils/config";
import { deepClone } from "@/utils";
import { S } from "mockjs";
import { formatDateTime } from "@/utils/dateUtil";
import { DeviceControlUtils } from "@/utils/DeviceControlUtils";
import { DeviceUtils } from "@/utils/DeviceUtils";
/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
    MeterChatDialog,
    MeterEditDialog,
  },
})
export default class Meters extends Vue {
  private sendCmd: string = "";
  private textarea: string = "";
  private textarea1: string = "";
  private mqttClient: mqtt.MqttClient = <mqtt.MqttClient>{};
  private searchMeterGateway: string = "";
  private selectDeviceId: string = "";
  private oldSearchMeterGateway: string = "";
  private deviceList: Device[] = [];
  private selectDeviceList: Device[] = [];
  private propertyList: any = [];
  private listLoading: boolean = true;
  private total = 0;
  private gatewayMeters: Meter[] = [];
  private deviceConfig: any = null;
  private selectMulitPropertyAction: string = "GET";
  private selectMulitPropertyActions: string[] = ["GET", "SET"];
  private selectPropertyList: any = [];
  private selectProperty: string = "";
  private sequenceList: number[] = [];
  private bindIds: string[] = [];
  private deviceControlUtils: DeviceControlUtils = new DeviceControlUtils();
  private deviceUtils: DeviceUtils = new DeviceUtils();
  private parseResponse(msg: string) {
    let json: any = JSON.parse(msg);
    console.log("parseResponse", json);
    if (json["devices"]) {
      this.deviceList = [];
      let devices: any = json["devices"];
      for (var i = 0; i < devices.length; i++) {
        var d: Device = <Device>{};
        let id: string = devices[i].id;
        let cls: string = devices[i].cls;
        let cls1 = cls.slice(0, 6);
        let cls2 = cls.slice(6, 8);
        d.class = cls;
        d.deviceId = id;
        d.status = "N/A";
        d.inUse = "No";
        if (!this.deviceConfig["class"][cls1]) {
          d.className = "unknown" + cls2;
        } else {
          d.className = this.deviceConfig["class"][cls1]["en"] + cls2;
        }
        this.deviceList.push(d);
      }
      this.bindIdToDevices();
    } else if (json["properties"]) {
      this.getProperties(json["properties"]);
    } else if (json["id"]) {
      this.bindIds = json["id"];
      this.bindIdToDevices();
    }
  }

  private bindIdToDevices() {
    this.selectDeviceList = [];
    let mapId: Map<string, boolean> = new Map();
    for (let i = 0; i < this.bindIds.length; i++) {
      mapId.set(this.bindIds[i], true);
    }
    console.log(mapId);
    for (let i = 0; i < this.deviceList.length; i++) {
      if (mapId.get(this.deviceList[i].deviceId)) {
        if (this.deviceList[i].status != "Online") {
          this.deviceList[i].status = "Online";
        }
        if (this.deviceList[i].inUse != "Yes") {
          this.deviceList[i].inUse = "Yes";
        }
        this.selectDeviceList.push(this.deviceList[i]);
      } else {
        if (this.deviceList[i].status != "N/A") {
          this.deviceList[i].status = "N/A";
        }
        if (this.deviceList[i].inUse != "No") {
          this.deviceList[i].inUse = "No";
        }
      }
    }
    this.deviceControlUtils.setDeviceList(this.deviceList);
  }

  private geEpcFromProperties(properties) {
    this.selectPropertyList = this.deviceUtils.geEpcFromProperties(
      properties,
      this.propertyList
    );
    console.log(this.selectPropertyList);
  }
  private getProperties(properties) {
    if (this.sendCmd == "PPTS") {
      return this.geEpcFromProperties(properties);
    }
    for (let i = 0; i < this.selectPropertyList.length; i++) {
      if (properties[this.selectPropertyList[i].epc]) {
        console.log("111111111111", i, this.propertyList[i].epc);
        this.$set(
          this.selectPropertyList[i],
          "updatedAt",
          formatDateTime(new Date())
        );
        this.$set(
          this.selectPropertyList[i],
          "data",
          properties[this.selectPropertyList[i].epc]
        );
      }
    }
    console.log(this.selectPropertyList);
  }
  private onSelectGateway() {
    console.log(this.searchMeterGateway);
    if (
      !!this.oldSearchMeterGateway &&
      this.oldSearchMeterGateway != this.searchMeterGateway
    ) {
      this.unsubscribe(this.oldSearchMeterGateway);
    }
    if (!!this.searchMeterGateway) {
      this.subscribe(this.searchMeterGateway);
    }
    this.oldSearchMeterGateway = this.searchMeterGateway;
  }

  private onSelectDevices() {
    console.log(this.selectDeviceId);
    this.deviceControlUtils.onSelectDeviceId(this.selectDeviceId);
    let selectDevice = this.deviceControlUtils.getSelectDevice();
    this.propertyList =
      this.deviceConfig["command"][selectDevice.class.slice(0, 6)];
    if (!this.propertyList) {
      this.propertyList = [];
    }
    let commonPropertyList = this.deviceConfig["command"]["common"];
    let map: Map<string, boolean> = new Map();
    for (let i = 0; i < this.propertyList.length; i++) {
      map.set(this.propertyList[i].epc, true);
    }
    for (let i = 0; i < commonPropertyList.length; i++) {
      if (!map.get(commonPropertyList[i].epc)) {
        this.propertyList.push(commonPropertyList[i]);
      }
    }
  }

  private onSequenceSelect(epc: string) {}
  private async getGatewayMeters() {
    let response = await meters(<GetMetersReq>{
      meter: <Meter>{},
    });
    this.gatewayMeters = response.data.meters.list;
  }

  private created() {
    this.getConfig();
    this.getGatewayMeters();
    this.connectMqtt();
    this.listLoading = false;
    this.deviceUtils.getPropertyListFromFormat(
      [],
      "0x1241404040404000624200404000020282"
    );
  }

  private destroyed() {
    this.disConnectMqtt();
  }

  private connectMqtt() {
    console.log("connectMqtt", globalData.mqttHost);

    const options = {
      connectTimeout: 40000,
      clientId: "",
      username: "",
      password: "",
      clean: true,
    };
    this.mqttClient = mqtt.connect(globalData.mqttHost);
    let self = this;
    // mqtt连接
    this.mqttClient.on("connect", (e) => {
      console.log("连接成功:");
    });
    // 接收消息处理
    this.mqttClient.on("message", (topic, message) => {
      self.textarea1 = message.toString();
      self.parseResponse(message.toString());
    });
    // 断开发起重连
    this.mqttClient.on("reconnect", (error) => {
      console.log("正在重连:", error);
    });
    // 链接异常处理
    this.mqttClient.on("error", (error) => {
      console.log("连接失败:", error);
    });
  }

  private subscribe(meterId: string) {
    let topic = "Custom/to_web/device/" + meterId;
    console.log(topic);
    let self = this;
    this.mqttClient.subscribe(topic, { qos: 1 }, (error) => {
      if (!error) {
        self.search(meterId);
      } else {
        console.log("订阅失败", error);
      }
    });
  }
  private unsubscribe(meterId: string) {
    this.mqttClient.unsubscribe(
      "Custom/to_web/meter_version/" + meterId,
      { qos: 1 },
      (error) => {
        if (!error) {
          console.log("订阅成功22");
        } else {
          console.log("订阅失败");
        }
      }
    );
  }

  private disConnectMqtt() {
    console.log("disConnectMqtt");
    this.mqttClient.end();
  }

  private search(meterGateway: string) {
    this.map();
    this.dev();
  }
  private dev() {
    let json: any = {
      cmd: "DEV",
    };
    let data: string = JSON.stringify(json);
    this.realSendDeviceCommand(<SendDeviceCommandReq>{
      meterID: this.searchMeterGateway,
      comandType: "pass",
      data: data,
    });
  }
  private map() {
    let json: any = {
      cmd: "MAP",
    };
    let data: string = JSON.stringify(json);
    this.realSendDeviceCommand(<SendDeviceCommandReq>{
      meterID: this.searchMeterGateway,
      comandType: "pass",
      data: data,
    });
  }

  private export() {}

  private getProperty() {
    let selectDevice: Device = this.deviceControlUtils.getSelectDevice();
    let json: any = {
      id: selectDevice.deviceId,
      cls: selectDevice.class,
      cmd: "PPTS",
    };
    let data: string = JSON.stringify(json);
    this.realSendDeviceCommand(<SendDeviceCommandReq>{
      meterID: this.searchMeterGateway,
      comandType: "pass",
      data: data,
    });
  }
  private getOneProperty() {
    let selectDevice: Device = this.deviceControlUtils.getSelectDevice();
    let json: any = {
      id: selectDevice.deviceId,
      cls: selectDevice.class,
      cmd: "GET",
      act: [this.selectProperty],
    };
    let data: string = JSON.stringify(json);
    this.realSendDeviceCommand(<SendDeviceCommandReq>{
      meterID: this.searchMeterGateway,
      comandType: "pass",
      data: data,
    });
  }
  private setOneProperty() {
    let selectDevice: Device = this.deviceControlUtils.getSelectDevice();
    let json: any = {
      id: selectDevice.deviceId,
      cls: selectDevice.class,
      cmd: "SET",
      act: this.getSendingProperties([this.selectProperty]),
    };
    let data: string = JSON.stringify(json);
    this.realSendDeviceCommand(<SendDeviceCommandReq>{
      meterID: this.searchMeterGateway,
      comandType: "pass",
      data: data,
    });
  }
  private sendMultiProperty() {
    let tmep = JSON.stringify(this.propertyList);
    let pList = JSON.parse(tmep);
    pList = pList.filter(function (a) {
      return !!a.sequence;
    });

    pList = pList.sort(function (a, b) {
      return a.sequence - b.sequence;
    });
    let act: string[] = [];
    for (let i = 0; i < pList.length; i++) {
      act.push(pList[i].epc);
    }
    let selectDevice: Device = this.deviceControlUtils.getSelectDevice();
    let json: any = {
      id: selectDevice.deviceId,
      cls: selectDevice.class,
      act: act,
      cmd: this.selectMulitPropertyAction,
    };
    if (this.selectMulitPropertyAction == "SET") {
      json["act"] = this.getSendingProperties(act);
    }
    let data: string = JSON.stringify(json);
    this.realSendDeviceCommand(<SendDeviceCommandReq>{
      meterID: this.searchMeterGateway,
      comandType: "pass",
      data: data,
    });
  }
  private async getConfig() {
    let response = await getConfig();
    this.deviceConfig = response.data;
    console.log("this.deviceConfig", this.deviceConfig);
  }

  private getSendingProperties(properties: string[]): any {
    let resp: any = [];
    let map: Map<string, any> = new Map();
    for (let i = 0; i < this.selectPropertyList.length; i++) {
      let p = this.selectPropertyList[i];
      map.set(p.epc, p);
    }
    for (let i = 0; i < properties.length; i++) {
      let p = map.get(properties[i]);
      if (!!p) {
        let act = {};
        act[p.epc] = p.data;
        resp.push(act);
      }
    }
    return resp;
  }

  private realSendDeviceCommand(req: SendDeviceCommandReq) {
    if (!req.data) {
      return;
    }
    let json = JSON.parse(req.data);
    if (!json.cmd) {
      return;
    }
    this.sendCmd = json.cmd;
    sendDeviceCommand(req);
  }
}
